/**
 * 从「复制打开抖音… https://v.douyin.com/xxx」「【标题】 https://b23.tv/xxx」等粘贴中提取首个视频相关 URL。
 * 前端 webpack 使用；Node 端副本在 dbtoolnode服务器/utils/extractVideoUrl.js，修改逻辑时请同步两份。
 */

function stripTrailingJunk(url) {
  return String(url || '')
    .replace(/[),.;，。；、:：!?]+$/g, '')
    .replace(/[）】」』\]]+$/g, '')
}

function hostnameLooksLikeVideoHost(host) {
  const h = (host || '').replace(/^www\./i, '').toLowerCase()
  return (
    h === 'v.douyin.com'
    || h.endsWith('douyin.com')
    || h === 'b23.tv'
    || h.endsWith('bilibili.com')
    || h === 'v.kuaishou.com'
    || h.endsWith('kuaishou.com')
    || h.includes('weixin.qq.com')
  )
}

function extractVideoUrlFromPastedText(raw) {
  const s = String(raw || '')
    .trim()
    .replace(/\u00a0/g, ' ')
  if (!s) return ''

  try {
    const u = new URL(s)
    if ((u.protocol === 'http:' || u.protocol === 'https:') && hostnameLooksLikeVideoHost(u.hostname)) {
      return stripTrailingJunk(s)
    }
  } catch (e) {
    /* 整段不是单一合法 URL */
  }

  const patterns = [
    /https?:\/\/v\.douyin\.com\/[A-Za-z0-9_-]+\/?/gi,
    /https?:\/\/b23\.tv\/[A-Za-z0-9]+\/?/gi,
    /https?:\/\/v\.kuaishou\.com\/[A-Za-z0-9_-]+\/?/gi,
    /https?:\/\/(?:www\.)?kuaishou\.com\/[^\s【】]+/gi,
    /https?:\/\/(?:www\.)?douyin\.com\/[^\s【】]+/gi,
    /https?:\/\/(?:m\.)?bilibili\.com\/video\/[^\s【】]+/gi,
    /https?:\/\/(?:www\.)?bilibili\.com\/video\/[^\s【】]+/gi,
    /https?:\/\/(?:channels\.|wx\.)?weixin\.qq\.com\/[^\s【】]+/gi
  ]

  for (const re of patterns) {
    const m = re.exec(s)
    if (m && m[0]) return stripTrailingJunk(m[0])
  }

  const loose = s.match(/https?:\/\/[^\s【】\n]+/g)
  if (loose) {
    for (const cand of loose) {
      const c = stripTrailingJunk(cand)
      try {
        if (hostnameLooksLikeVideoHost(new URL(c).hostname)) return c
      } catch (e) {
        /* ignore */
      }
    }
  }

  const firstToken = s.split(/\s+/).find((w) => /^https?:\/\//i.test(w))
  return stripTrailingJunk(firstToken || s)
}

module.exports = { extractVideoUrlFromPastedText, stripTrailingJunk }
